import React, { useState } from 'react'
import styled from "styled-components"
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { selectCars } from '../features/car/carSlice';
import { useSelector } from 'react-redux';

function Header() {

    const [burgerStatus, setBurgerStatus] = useState(false);
    const cars = useSelector(selectCars);

    return (
        <Container>
            <Logo>
                <a>
                    <img src="./images/logo.svg" />
                </a>
            </Logo>
            <Menu>
                {cars && cars.map((car, index)=>(
                    <a key={index} href="#">{car}</a>
                ))}
                <a href="#">Solar Roof</a>
                <a href="#">Solar Panels</a>
            </Menu>
            <RightMenu>
                <a href="#">Shop</a>
                <a href="#">Account</a>
                <CustomeMenu onClick={() => setBurgerStatus(true)} />
            </RightMenu>
            <BurgerNav show={burgerStatus}>
                <CloseWrapper>
                    <CustomClose onClick={() => setBurgerStatus(false)}/>
                </CloseWrapper>
                {cars && cars.map((car, index)=>(
                    <li key={index}><a href="#">{car}</a></li>
                ))}
                <li><a href="#">Solar Roof</a></li>
                <li><a href="#">Solar Panels</a></li>
                <li><a href="#">Existing inventory</a></li>
                <li><a href="#">used inventory</a></li>
                <li><a href="#">Trade-in</a></li>
                <li><a href="#">Test Drive</a></li>
                <li><a href="#">Powerwall</a></li>
                <li><a href="#">Commercial Energy</a></li>
                <li><a href="#">Utilities</a></li>
                <li><a href="#">Charging</a></li>
                <li><a href="#">Find US</a></li>
                <li><a href="#">Support</a></li>

            </BurgerNav>

        </Container>
    )
}

export default Header

const Container = styled.div`
    min-height: 60px;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    top :0;
    left :0;
    right :0;
    z-index:1;

`
const Logo = styled.div`
 a img{
    
    width : 130px;
    display:flex;
    align-items: center;
    justify-content: center;
    padding-left: 12px;
    padding-bottom: 5px;
 }
    

`
const Menu = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    a{
        font-weight: 545;
        ${'' /* text-transform: uppercase; */}
        padding: 0 10px;
        flex-Wrap: nowrap;
    }

    @media (max-width: 1100px) {
        display: none;
    }

`

const RightMenu = styled.div`
    display: flex;
    align-items: center;
     a{
        font-weight: 545;
        ${'' /* text-transform: uppercase; */}
        margin-right:15px
        
    }
`

const CustomeMenu = styled(MenuIcon)`
    cursor: pointer;

`
const BurgerNav = styled.div`
    z-index: 16;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    background : white;
    width: 300px;
    list-style: none;
    padding: 20px;
    display: flex;
    flex-direction: column;
    text-align:start;
    transform: ${props => props.show ? 'translateX(0)': 'translateX(100%)' };
    transition: transform 0.2s ease-in-out;
    li {
        padding:15px 0;
        border-bottom: 1px solid rgba(0, 0, 0, .2);
        a{
            font-weight: 550;
        }
    }


`
const CustomClose = styled(CloseIcon)`
    cursor: pointer;
`
const CloseWrapper = styled.div`
    display: flex;
    justify-content: flex-end;

`